<template>
  <div class="flex align-items-center department-item one">
    <div class="content-item-label">建议科室</div>
    <el-cascader
      placeholder="请选择科室"
      :value="select"
      :options="departmentList"
      :props="departmentProps"
      @change="changeDepartment"
      :show-all-levels="false"
      ref="cascader"
    ></el-cascader>
  </div>
</template>

<script>
export default {
  name: "department",
  props: ['selectedDeparttId', 'departmentList'],
  data() {
    return {
      oldSelectedDeparttId: [],
      newList: [],
      departmentProps: {
        multiple: true,
        checkStrictly: true,
        value: "departId",
        label: "departName",
        children: "departmentDTOList"
      },
    }
  },
  updated() {
    let _this = this;
    //改写el函数
    this.$refs.cascader.computePresentTags = function () {
      const {isDisabled, leafOnly, showAllLevels, separator, collapseTags} = this;
      const checkedNodes = this.getCheckedNodes(leafOnly);
      const tags = [];
      const genTag = node => ({
        node,
        key: node.uid,
        text: node.getText(showAllLevels, separator),
        hitState: false,
        closable: !isDisabled && !node.isDisabled
      });
      if (checkedNodes.length) {
        if (collapseTags) {
          tags.push({
            key: -1,
            text: `+ ${checkedNodes.length}`,
            closable: false
          });
        } else {
          _this.select.forEach((item, index) => {
            const nodeItem = checkedNodes.filter(nodeItem => {
              //匹配菜单层级
              if (item.length == nodeItem.level && nodeItem.value == item[item.length - 1]) return nodeItem;
            });
            tags.push(genTag(nodeItem[0]));
          })
        }
      }
      this.checkedNodes = checkedNodes;
      this.presentTags = tags;
    }
    this.$refs.cascader.computePresentTags.call(this.$refs.cascader);
  },
  mounted() {
    Array.prototype.diff = function (a) {
      return this.filter(function (i) {
        return a.indexOf(i) < 0;
      });
    };
  },

  computed: {
    select: {
      get() {
        return this.selectedDeparttId
      },
      set(val) {
        this.$emit('update:selectedDeparttId', val)
      }
    }
  },
  methods: {
    changeDepartment(val) {
      // 回显赋值
      this.newList = [...this.select]
      let _val = val.map(item => {
        return item.toString();
      })
      let _newList = this.newList.map(item => {
        return item.toString();
      })
      // 删除
      if (this.newList.length > val.length) {
        let remove = _newList.diff(_val);
        this.newList.splice(_newList.indexOf(remove[0]), 1);
      } else {
        // 增加 查找新增项
        let add = _val.diff(_newList);
        this.newList.push(val[_val.indexOf(add[0])]);
      }
      if (this.newList.length > 5) {
        this.$message.error("最多选择5个科室");
        this.newList.pop();
      }
      this.select = [...this.newList];
    },
  }
}
</script>

<style scoped lang="scss">

.department-item {
  font-size: 14px;
  color: #2c3443;
  margin-top: 20px;
  position: relative;
  width: 50%;

  .content-item-label {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;

    span {
      color: #f62458;
      margin-right: 5px;
    }
  }
}
</style>
